/* eslint-disable react/no-danger */
import React, { FunctionComponent } from 'react';

import { forNamespace } from 'app/common/lib/util/i18n';
import { PrimaryButton } from 'app/common/components/controls/button/button';
import { OnboardingDialog } from './OnboardingDialog';

import { AtlassianAccountOnboardingLinks } from './AtlassianAccountOnboardingLinks';
// eslint-disable-next-line @trello/less-matches-component
import styles from './AtlassianAccountOnboardingOverlay.less';

const format = forNamespace(['aa onboarding', 'dialog']);
interface WorkAndOtherProps {
  orgName: string;
  onClickSetupAccount: () => void;
  onClickGoBack: () => void;
  onDismiss: () => void;
  image?: HTMLImageElement;
}

export const WorkAndOther: FunctionComponent<WorkAndOtherProps> = ({
  orgName,
  onClickSetupAccount,
  onClickGoBack,
  onDismiss,
  image,
}) => (
  <OnboardingDialog
    closeDialog={onDismiss}
    title={format('one thing to keep in mind')}
    helpLink={AtlassianAccountOnboardingLinks.Help}
    image={image}
  >
    <div>
      <p>{format('managed by org', { org: orgName })}</p>
    </div>
    <div>
      <p
        dangerouslySetInnerHTML={{
          __html: format('set up new account', {
            org: orgName,
            signupUrl: AtlassianAccountOnboardingLinks.Signup,
            transferBoardsUrl: AtlassianAccountOnboardingLinks.TransferBoards,
          }),
        }}
      />
    </div>
    <div className={styles.section}>
      <PrimaryButton onClick={() => onClickSetupAccount()}>
        {format('set up org account button', { org: orgName })}
      </PrimaryButton>
    </div>
    <div className={styles.item}>
      <a role="link" onClick={() => onClickGoBack()}>
        {format('go back')}
      </a>
    </div>
  </OnboardingDialog>
);
